import { AdminReviewResponse, VerifyRecordResponse, HACCPTableName } from '../types/adminReview';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3003/api';

export const adminReviewApiService = {
  /**
   * Fetch all incomplete HACCP records across all 6 tables
   */
  fetchIncompleteRecords: async (): Promise<AdminReviewResponse> => {
    try {
      const response = await fetch(`${API_BASE_URL}/admin-review`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to fetch incomplete records');
      }

      return data;
    } catch (error) {
      console.error('Error fetching incomplete records from API:', error);
      throw error;
    }
  },

  /**
   * Verify a record by updating its verified_by field
   */
  verifyRecord: async (
    table: HACCPTableName,
    id: string,
    verifiedBy: string
  ): Promise<VerifyRecordResponse> => {
    try {
      const response = await fetch(`${API_BASE_URL}/admin-review/verify/${table}/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ verifiedBy })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to verify record');
      }

      return data;
    } catch (error) {
      console.error('Error verifying record:', error);
      throw error;
    }
  }
};
